import { db, firebaseAuth } from './firebaseConfig';
import I18n from 'core/I18n/I18n';
import keyEnum from 'core/I18n/KeyEnum';
import EntityEnum from './EntityEnum';
import { getItem, addItem, deleteItem, updateItem, execute } from './firebaseFunctions';
import { emailRegex } from './validator/Regex';
import { getScopeHasPower } from 'core/utils/Utils';

/** Register User actions */
export const registerUser = async ({ id, name, email, password }) => {
    const userEmail = await getItem("Users", { email }, false);

    if (userEmail && userEmail[0].id === id) {
        try {
            await firebaseAuth().createUserWithEmailAndPassword(email, password);
            // await firebaseAuth().currentUser.sendEmailVerification();

            return db.collection('Users').doc(id).set({ name, email, invite: false }, { merge: true });
        } catch (e) {
            throw new Error(I18n[keyEnum.emailAlreadyExists]);
        }
    } else {
        throw new Error(I18n[keyEnum.emailAlreadyExists]);
    }
}

/** Do login with Registered User */
export const doLogin = async (email, password) => {
    try {
        return firebaseAuth().setPersistence(firebaseAuth.Auth.Persistence.LOCAL).then(async () => {
            const loggedUser = await firebaseAuth().signInWithEmailAndPassword(email, password);

            if (loggedUser) {
                return verifyUser(loggedUser.user);
            } else {
                throw new Error(I18n[keyEnum.loginNotExists]);
            }
        })
    } catch (e) {
        throw new Error(I18n[keyEnum.invalidPassword]);
    }
}

export const verifyUser = async (loggedUser) => {
    if (loggedUser) {
        const arrUser = await getItem("Users", { email: loggedUser.email, isAdmin: true });
        if (arrUser && arrUser.length > 0) {
            const user = arrUser[0];
            return user;
        } else {
            throw new Error(I18n[keyEnum.loginNotExists]);
        }
    } else {
        throw new Error(I18n[keyEnum.loginNotExists]);
    }
}

/** Do login with Registered User */
export const userRecovery = async (email) => {
    try {
        await firebaseAuth().sendPasswordResetEmail(email);
    } catch (e) {
        throw new Error(I18n[keyEnum.loginNotExists]);
    }
}

export const getInvite = async (id) => {
    const users = db.collection(EntityEnum.user).doc(id);

    return users.get().then(document => {
        if (document.exists) {
            const user = document.data();
            return (user && user.invite) && user;
        } else {
            throw new Error(I18n[keyEnum.inviteExpired]);
        }
    })
}


export const addInvite = async (item) => {
    return;
}

export const deleteInvite = async (id) => {
    return;
}

export const updateInvite = async (item) => {
    return;
}

export const getUsersAll = (scope) => {
    if (scope && scope.value) {
        const table = db.collection("Users").where("active", "==", true);
        const clauseHasPower = table.where("groups", 'array-contains', { hasPower: true, details: groupReference(scope) });
        const clauseNormalPower = table.where("groups", 'array-contains', { hasPower: false, details: groupReference(scope) });

        const usersHasPower = execute(clauseHasPower);
        const usersNormal = execute(clauseNormalPower);

        return Promise.all([usersHasPower, usersNormal]).then((arrUsers) => {
            const users = [].concat(...arrUsers);
            return users;
        });
    } else {
        throw new Error(I18n[keyEnum.groupFieldRequired]);
    }
}

export const getUsers = async () => {
    return getItem(`Users`, {}, false)
}

export const groupReference = (item) => {
    return db.collection("Groups").doc(item.value);
}

export const userReference = (item) => {
    return db.collection("Users").doc(item.value);
}

const authGroup = (scope, hasPower = false) => {
    return [{ hasPower, details: groupReference(scope) }]
}

export const addUser = async (item, dispatch, updateUserData) => {
    const { email, tags, name, active } = item;
    if (email && emailRegex.test(email)) {
        const arrUser = await getItem("Users", { email }, false);
        const nameUser = name ? name : email.split("@")[0];
        const tagsUser = tags ? tags : []
        if (!arrUser || arrUser.length === 0) {
            const newUser = await addItem("Users", { email, tags: tagsUser, name: nameUser });
            const password = Math.random().toString(36).slice(-6);
            const settedUser = await registerUser({ id: newUser.id, name: nameUser, email: email, password: password })
            try {
                sendEmailInvite(newUser.id, newUser.email, password);
            } catch (e) { }
            return newUser;
        } else {
            const dataUser = arrUser[0];
            const updatedUser = await dispatch(updateUserData({
                id: dataUser.id, tags, active
            }))
            return updatedUser;
        }
    } else {
        console.log("email não é válido")
        // throw new Error(`${email}: ${I18n[keyEnum.invalidEmail]}`);
    }
}

// https://us-central1-aqto-360.cloudfunctions.net/api3
export const sendEmailInvite = async (id, email, password) => {
    return fetch(`https://us-central1-ricodomingues-2d361.cloudfunctions.net/api3/sendInvite?invite=${id}&email=${email}&password=${password}`);
}

export const deleteUser = async ({ newData, scope }) => {
    const groups = newData.groups.filter(item => item.details.id !== groupReference(scope).id);
    return updateItem("Users", { id: newData.id, groups });
}

export const updateAuthUser = async (item) => {
    const { newData, userType, scope } = item;
    if (!userType) {
        const groupIndex = newData.groups.findIndex(item => item.details.id === groupReference(scope).id);
        newData.groups[groupIndex] = authGroup(scope, !getScopeHasPower(newData, scope))[0];
    }
    const { id, groups } = newData;
    return updateItem("Users", { id, groups, userType });
}

export const updateUser = async (item) => {
    return updateItem("Users", item);
}

// localhost:5000/api3/sendInvite?invite=d0lKepTdrUrv08op8rDE&email=everton.bernardes.12@gmail.com

/**
 * const users = db.collection(EntityEnum.user);
    const query = users.where('invite', '==', true);

    return query.get().then(snapshot => {
        if (snapshot.empty) {
            return;
        } else {
            snapshot.docs.forEach(document => {
                if (document.exists && document.id === id) {
                    return document;
                } else {
                    throw new Error(I18n[keyEnum.inviteExpired]);
                }
            });
            return;
        }
    })
 */